package br.com.texeratx.boardgametimeapp.core.utils

import kotlinx.datetime.LocalDate

/**
 * Datas KMP:
 * - API usa ISO: yyyy-MM-dd
 * - UI usa: dd/MM/yyyy
 *
 * Usamos kotlinx-datetime (funciona Android + iOS).
 * E fazemos a conversão com parse/format manual simples.
 */

// yyyy-MM-dd (ou yyyy-MM-dd'T'HH:mm)  ->  dd/MM/yyyy
fun String.apiToUiDate(): String {
    if (this.isBlank()) return "-"
    return runCatching {
        val datePart = this.substringBefore('T') // tolera datetime
        val date = LocalDate.parse(datePart) // aceita ISO yyyy-MM-dd
        date.toUiString()
    }.getOrDefault("-")
}

// dd/MM/yyyy  ->  yyyy-MM-dd
fun String.uiToApiDateOrNull(): String? {
    val raw = this.trim()
    if (raw.isBlank()) return null

    return runCatching {
        val (day, month, year) = raw.split("/")
            .map { it.trim() }

        // validações básicas
        val d = day.toInt()
        val m = month.toInt()
        val y = year.toInt()

        // cria LocalDate validando calendário
        LocalDate(year = y, monthNumber = m, dayOfMonth = d).toString() // ISO yyyy-MM-dd
    }.getOrNull()
}

private fun LocalDate.toUiString(): String {
    val dd = dayOfMonth.toString().padStart(2, '0')
    val mm = monthNumber.toString().padStart(2, '0')
    val yyyy = year.toString().padStart(4, '0')
    return "$dd/$mm/$yyyy"
}
